/** Rendering tiers. `?quality=low|medium|high` overrides detection (handy for testing). */
export type QualityTier = 'low' | 'medium' | 'high';

export interface QualityProfile {
  tier: QualityTier;
  dpr: number;
  layers: 'full' | 'two';
  particles: number;
  post: boolean;
  shafts: boolean;
}

let cached: QualityProfile | null = null;

export function getQuality(): QualityProfile {
  if (cached) return cached;
  const params = new URLSearchParams(window.location.search);
  const forced = params.get('quality') as QualityTier | null;
  const nav = navigator as Navigator & { deviceMemory?: number; connection?: { saveData?: boolean } };
  const coarse = window.matchMedia?.('(pointer: coarse)').matches ?? false;
  const cores = nav.hardwareConcurrency || 4;
  const mem = nav.deviceMemory ?? 4;
  let tier: QualityTier = 'high';
  if (mem <= 3 || nav.connection?.saveData || (coarse && cores <= 4)) tier = 'low';
  else if (coarse || cores <= 4) tier = 'medium';
  if (forced === 'low' || forced === 'medium' || forced === 'high') tier = forced;
  const dprRaw = window.devicePixelRatio || 1;
  cached =
    tier === 'high'
      ? { tier, dpr: Math.min(dprRaw, 1.75), layers: 'full', particles: 650, post: true, shafts: true }
      : tier === 'medium'
        ? { tier, dpr: Math.min(dprRaw, 1.3), layers: 'full', particles: 260, post: true, shafts: true }
        : { tier, dpr: 1, layers: 'full', particles: 90, post: false, shafts: false };
  return cached;
}
